import { useMemo } from "react";
import { useActivitiesContext } from "./ActivitiesContext";
import { useActivities } from "./useActivities";
import { ActivityEventSource } from "./sources/ActivityEventSource";

export function useWorkspaceActivities() {
    const { workspaceId, userId, database, kinds } = useActivitiesContext();
    const sources = useMemo(
        () =>
            workspaceId && database
                ? [new ActivityEventSource(workspaceId, userId, database, kinds)]
                : [],
        [workspaceId, userId, database, kinds]
    );
    return useActivities(sources);
}
